"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMapIcon = void 0;
var _mui = require("@ori-ui/mui");
var _mapIconInfo = require("./mapIconInfo");
/**
 * Based on icon type and if it is selected will return data needed for generating icon
 * @param data MapIconProps
 * @returns mapData (width, height, v-box, color, inner color, shadow x & y)
 */
const useMapIcon = data => {
  const theme = (0, _mui.useTheme)();
  const {
    iconType,
    isSelected
  } = data;
  const mapData = {
    width: 42,
    height: 50,
    vBox: '0 0 42 50',
    color: theme.palette.default.main,
    innerColor: theme.palette.common.white,
    shadowX: 0,
    shadowY: 0
  };
  if (isSelected) {
    mapData.width = _mapIconInfo.mapIconInfo.pinSelected.width;
    mapData.height = _mapIconInfo.mapIconInfo.pinSelected.height;
    mapData.color = theme.palette.primary.main;
  }
  if (iconType === 'cluster') {
    mapData.width = _mapIconInfo.mapIconInfo.cluster.width;
    mapData.height = _mapIconInfo.mapIconInfo.cluster.height;
    mapData.vBox = `0 0 ${_mapIconInfo.mapIconInfo.cluster.width} ${_mapIconInfo.mapIconInfo.cluster.height}`;
    mapData.shadowX = 0.246033;
    mapData.shadowY = 0.0297852;
    mapData.color = theme.palette.default.main;
  }
  if (iconType === 'currentLocation') {
    mapData.width = _mapIconInfo.mapIconInfo.currentLocation.width;
    mapData.height = _mapIconInfo.mapIconInfo.currentLocation.height;
    mapData.vBox = `0 0 ${_mapIconInfo.mapIconInfo.currentLocation.width} ${_mapIconInfo.mapIconInfo.currentLocation.height}`;
    mapData.color = theme.palette.info.dark;
  }
  return {
    mapData
  };
};
exports.useMapIcon = useMapIcon;
